import React from 'react';
import styled from "@emotion/styled";
import { colors } from 'src/theme';
import { i18n } from 'src/common';
import { Flex, Text } from 'src/components';
import { Card } from './card';
import { IconPhoneCall } from '@kompare/kompare-ui-library';

const CardStyle = styled(Card)({
  width: '100%',
  borderWidth: 1,
  borderStyle: 'dashed',
  borderColor: colors.border3,
  padding: '16px',

  '&:hover': {
    borderColor: colors.primary
  }
})

const ButtonStyle = styled.button({
  border: `2px solid ${colors.primary}`,
  borderRadius: '8px',
  backgroundColor: 'transparent',
  color: colors.primary,
  fontSize: '16px',
  lineHeight: '18px',
  fontWeight: 700,
  fontFamily: "'Red Hat Text', sans-serif",
  padding: '10px 16px',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  minWidth: '130px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.2s ease',

  '&:hover': {
    backgroundColor: colors.primary,
    color: colors.white
  }
})

export interface RequestAgentCardV2Props {
  title?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
}

export const RequestAgentCardV2: React.FC<RequestAgentCardV2Props> = ({
  title = i18n.t('components.cards.requestAgentCard.title'),
  buttonLabel = i18n.t('components.cards.requestAgentCard.buttonLabel'),
  onButtonClick = () => console.log('click')
}) => (
  <CardStyle radius={8} background='transparent'>
    <Flex gap={8} justify='space-between' align='center'>
      <Flex gap={8} align='center' style={{ flex: 1 }}>
        <IconPhoneCall color={colors.icon2} width={16} height={16} />
        <Text type='base' style={{ fontSize: '14px', lineHeight: '20px', color: colors.text2 }}>
          {title}
        </Text>
      </Flex>
      <ButtonStyle onClick={onButtonClick}>
        {buttonLabel}
      </ButtonStyle>
    </Flex>
  </CardStyle>
);
